// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"204":"294751f9","774":"d2801834","821":"ba3ad90c"}[chunkId] + ".v1.js";
};